// $(window).load(function() {
 
// });

// $(document).ready(function () {
  

//   if ($('.read-more-content').html() == "") {
// //      alert("is  empty");
//      $('.read_more_button_parent').hide();
//   }else{
// //      alert("is not empty");
//      $('.read_more_button_parent').show();
    
//   }
  
  
  $('.read_more_button').click(function(){
        var text =  $(this).html();
        if(text === 'Read More'){
          $(this).html('Read Less');
          $('.read-more-content').css('max-height','100%','height','100%');
          $(this).parent().css({'background-image':'none', 'margin':'0px 0px', 'padding': '0px 0px', 'position': 'inherit'});
        }else{
          $(this).html('Read More');
          $('.read-more-content').css('max-height','160px', 'height','160px;');
          $(this).parent().css({'background-image':'linear-gradient(to bottom, transparent, rgb(253 253 253))','position': 'absolute','margin':'40px 0px 0px', 'padding': '30px 0px 8px'});
        }
   }); 
   
// });   

// function gtag_report_conversion(url) {
//   var callback = function () {
//     if (typeof(url) != 'undefined') {
//       window.location = url;
//     }
//   };
//   gtag('event', 'conversion', {
//       'send_to': 'AW-413226119/RQ8gCLu8_fgBEIephcUB'
// //       'event_callback': callback
//   });
//   return false;
// }


function gtag_report_conversion(){
 gtag('event', 'conversion', {
      'send_to': 'AW-413226119/RQ8gCLu8_fgBEIephcUB'
//       'event_callback': callback
  });
}

// function gtag_report_conversion_checkout(url) {
//   var callback = function () {
//     if (typeof(url) != 'undefined') {
//       window.location = url;
//     }
//   };
//   gtag('event', 'conversion', {
//       'send_to': 'AW-413226119/mXkUCMyhkvkBEIephcUB'
// //       'event_callback': callback
//   });
//   return false;
// }

function gtag_report_conversion_checkout(){
  gtag('event', 'conversion', {
      'send_to': 'AW-413226119/mXkUCMyhkvkBEIephcUB'
//       'event_callback': callback
  });
}


function gtag_report_conversion_subscription(){
  gtag('event', 'conversion', {
      'send_to': 'AW-413226119/Y-20CIbAn_kBEIephcUB'
//       'event_callback': callback
  });
}

// function gtag_report_conversion_subscription(url) {
//   var callback = function () {
//     if (typeof(url) != 'undefined') {
//       window.location = url;
//     }
//   };
//   gtag('event', 'conversion', {
//       'send_to': 'AW-413226119/Y-20CIbAn_kBEIephcUB'
// //       'event_callback': callback
//   });
//   return false;
// }

